import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button';

const IntroductionScreen = ({ onClick }) => (
  <>
    <h1>Supporting small businesses through the ups and downs.</h1>
    <p className="text-large">
      Interested in easy, modern payroll and benefits? Start with a few questions about your
      business.
    </p>
    <Button
      className="btn btn-primary margin-top-10px full-width"
      label="Get started"
      onClick={onClick}
    />
    <div className="margin-bottom-15px padding-top-15px text-center">
      Does your company use Gusto today?{' '}
      <span className="d-block d-lg-inline">
        <a href={window.loginBaseUrl}>Sign in here</a>.
      </span>
    </div>
  </>
);

IntroductionScreen.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default IntroductionScreen;
